import DBMgr from "@/Core/DBMgr";
import KitLog from "./KitLog";
import {KitTrack} from "./Track/KitTrack";
import {JsonData} from "@/Fwk/Kit/JsonData";

export class KitSp
    {
        private static _data: JsonData = new JsonData();
        private static SP_NAME = "db_kit";
        private static _hash:number = 0;
        private static _saveHash:number = -1;

        static Init() {
            let data = DBMgr.GetData(this.SP_NAME);
            if (data) {
                try {
                    this._data = new JsonData(null, data);
                } catch (error) {
                    if (KitLog.IsLog) KitTrack.Log(`Web数据库-读取数据解密：错误:${error}`);
                }
            } else {
                this._data = new JsonData();
            }
        }

        public static GetString(key: string, def: string = ""): string {
            return this._data?.OptString(key, def);
        }

        public static SetString(key: string, v: string) {
            this._data?.put(key, v);
        }

        public static GetInt(key: string, def = 0): number {
            return this._data?.OptInt(key, def);
        }

        public static SetInt(key: string, v: number) {
            this._data.put(key, v);
        }

        public static ReadAllStringKVs(): Map<string, string> {
            return this._data.ReadAllStringKVs();
        }

        public static Remove(key: string) {
            this._data.Remove(key);
        }

        public static Save() {
            if (this._saveHash == this._hash) return;
            let str = this._data.toString();
            this._saveHash = this._hash;
            DBMgr.UpdateData(this.SP_NAME, str);
        }

        public static Apply() {
            this._hash++;
        }

}